import { createContext, useState } from "react";

export const context = createContext();

const { Provider } = context;

const ValuationContext = ({ children }) => {
    const [dataProperty, setProperty] = useState([]);
    const [dataFeatures, setFeatures] = useState([]);
    const [dataAmenities, setAmenities] = useState([]);
    const [dataCommonAmenities, setCommonAmenities] = useState([]);
    const [dataUser, setDataUser] = useState([]);
    const [step, setStep] = useState(0);
    const [inCondo, setInCondo] = useState(true);

    const addDataProperty = (data) => {
        setProperty(data);
    };

    const addDataFeatures = (data) => {
        setFeatures(data);
    };

    const addDataAmenities = (data) => {
        setAmenities(data);
    };

    const addDataCommonAmenities = (data) => {
        setCommonAmenities(data);
    };

    const addDataUser = (data) => {
        setDataUser(data);
    };

    const updateStep = (step) => {
        setStep(step);
    };

    const updateInCondo = (inC) => {
        setInCondo(inC);
    };

    return (
        <Provider
            value={{
                dataProperty,
                dataFeatures,
                dataAmenities,
                dataCommonAmenities,
                dataUser,
                step,
                inCondo,
                addDataProperty,
                addDataFeatures,
                addDataAmenities,
                addDataCommonAmenities,
                addDataUser,
                updateStep,
                updateInCondo,
            }}
        >
            {children}
        </Provider>
    );
};

export default ValuationContext;
